import { Component, Input, ElementRef, AfterContentInit } from '@angular/core';

@Component({
    selector: 'app-sort-option',
    template: '<ng-content></ng-content>'
})
export class SortOptionComponent implements AfterContentInit {
    @Input() value: string;
    label: string;

    constructor (private el: ElementRef) {}

    ngAfterContentInit () {
        this.label = this.el.nativeElement.innerText;
    }
}
